// @flow

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { log } from '../../utils/jsUtils';
import { selectUser } from '../../reduxStore/modules/user/selectors';

import AppBar from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';

import HeaderTopBar from '../HeaderTopBar';

import { createClasses } from '../../utils/stylesUtils';
import styles from './Styles/IntegrationsHeader.Style';

type Props = {
  mobileOpen: bool, 
  usehandleDrawerToggle: Function,
};

const IntegrationsHeader = (props: Props) => {
  log('[IntegrationsHeader] props: ', props);
  const {
    usehandleDrawerToggle
  } = props;

  const theme = useTheme();
  const classes = createClasses(styles, theme);
  const user = useSelector(selectUser);

  return (
    <AppBar 
      sx={classes.appBar}
      position="fixed"
    >
      <Toolbar
        sx={classes.toolbarSingleRow}
        disableGutters
      >
        <Grid 
          container
          direction='column'
        >
          <HeaderTopBar
            usehandleDrawerToggle={usehandleDrawerToggle}
          >
            <Typography 
              sx={classes.pageTitle}
              variant='h2'
            >
              <a href='/integrations'>{'Integrations'}</a>
            </Typography>
          </HeaderTopBar>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default IntegrationsHeader;
